import React, {
  useCallback,
  useEffect,
  useState,
} from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { compareDate } from '../comparators/compareDate';
import { DateFilter } from '../filters/DateFilter';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import { debounce } from 'lodash';
import {DateTimeField} from '@mui/x-date-pickers';
import { DateTimePicker } from '@mui/x-date-pickers';

export const SPDateTimeField: FieldComponent<
  string,
  string[],
  { loading?: boolean }
> = ({ onChange, defaultValue, forcedValue, disabled, isMissing, schema }) => {
  const [currentState, setCurrentState] = useState<any>({
    value: undefined,
    send: false,
  });

  const debouncedChange = useCallback(
    debounce((newValue) => {
      onChange(newValue);
    }, 500),
    []
  );

  useEffect(() => {
    if (defaultValue) {
      setCurrentState({
        value: defaultValue,
        send: false,
      });
    }
  }, [defaultValue]);

  useEffect(() => {
    if (currentState.send) {
      debouncedChange(currentState.value);
    }
  }, [currentState, debouncedChange]);

  const handleChange = (value: any) => {
    setCurrentState({
      value: value,
      send: true,
    });
  };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en-gb'}>
        <DateTimePicker
          disabled={disabled}
          className={`w-full ${isMissing ? 'error' : ''}`}
          label={`${isMissing ? 'This field is missing' : ''}`}
          value={
            currentState.value === undefined ? null : dayjs(currentState.value)
          }
          onChange={(value, context) => {
            handleChange(
              dayjs(value, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm')
            );
          }}
          slotProps={{
            textField: {
              size: 'small',
            },
          }}
          format={'YYYY-MM-DD HH:mm'}
          minutesStep={15}
        />
      </LocalizationProvider>
    </>
  );
};

SPDateTimeField.includes = (query = [], value) =>
  query.length === 0 ||
  (value !== undefined &&
    query.some((date) => compareDate(new Date(date), new Date(value)) === 0));

SPDateTimeField.comparator = (one = '', other = '') => {
  if (one === other) return 0;
  return one < other ? -1 : 1;
};

SPDateTimeField.FilterRenderer = DateFilter;
